export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <div className="relative w-full max-w-lg mx-auto">
              <img
                src="https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20manga%20books%20scattered%2C%20warm%20ambient%20lighting%2C%20cream%20and%20coral%20color%20palette%2C%20comfortable%20atmosphere%2C%20soft%20natural%20light%2C%20minimalist%20composition%2C%20reading%20culture%20vibe&width=900&height=700&seq=about-manga-platform&orientation=landscape"
                alt="YY漫画网 关于我们 免费漫画平台"
                className="w-full h-auto rounded-xl"
              />
            </div>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-sm font-medium mb-5">
              <i className="ri-information-line"></i>
              <span>关于YY漫画网</span>
            </div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-5">
              专注漫画阅读的在线平台
            </h2>
            <div className="space-y-3 text-foreground-600 text-sm md:text-base leading-relaxed">
              <p>
                YY漫画网致力于为广大漫画爱好者提供优质的在线阅读体验。我们聚合了
                韩漫、日漫、国漫等多元漫画资源，涵盖热血、恋爱、奇幻、悬疑、搞笑、
                都市、武侠、穿越等丰富题材，满足不同读者的口味需求。
              </p>
              <p>
                平台支持全集漫画免费下拉式阅读，无需翻页等待，流畅舒适的阅读体验
                让你沉浸其中。每日同步更新热门漫画最新话，追更不等待，精彩不错过。
              </p>
              <p>
                我们用心筛选每一部作品，通过漫画排行榜和专题推荐帮助读者快速发现
                值得追的好漫画。YY漫画网，让好看的漫画触手可及。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}